import { cn } from "@/lib/utils";
import { ArrowBigDown, ArrowBigUp } from "lucide-react";
import NumberFlow from "@number-flow/react";
import { Button } from "@/components/ui/button";

interface UpvoteRatingAnimatedProps {
  voteScore: number;
  upvoted: boolean;
  downvoted: boolean;
  upvoteIncrement?: number;
  downvoteIncrement?: number;
  onVoteChange: (vote: "upvote" | "downvote") => void;
}

const Rating = ({
  voteScore,
  downvoted,
  onVoteChange,
  upvoted,
}: UpvoteRatingAnimatedProps) => {
  return (
    <div
      className={cn(
        "flex w-fit flex-row items-center gap-0 rounded-full",
        upvoted && "bg-primary-wu",
        downvoted && "bg-gray-wu"
      )}
    >
      <Button
        aria-label="Upvote"
        onClick={(e) => onVoteChange("upvote")}
        variant="ghost"
        size="icon"
        className={cn(
          "dark:hover:bg-button-hover-background-wu hover:bg-button-hover-background-wu rounded-full p-2",
          upvoted &&
            "dark:hover:bg-primary-wu hover:bg-primary-wu hover:brightness-90 dark:hover:brightness-90",
          downvoted &&
            "dark:hover:bg-gray-wu hover:bg-gray-wu hover:brightness-90 dark:hover:brightness-90"
        )}
      >
        <ArrowBigUp
          className={cn(
            "size-6",
            "text-black dark:text-white",
            upvoted && "fill-white text-transparent"
          )}
        />
      </Button>

      <span className="min-w-8 p-1 text-center text-black dark:text-white">
        <NumberFlow format={{ notation: "compact" }} value={voteScore} />
      </span>

      <Button
        onClick={(e) => onVoteChange("downvote")}
        aria-label="Downvote"
        variant="ghost"
        size="icon"
        className={cn(
          "dark:hover:bg-button-hover-background-wu hover:bg-button-hover-background-wu rounded-full p-2",
          upvoted &&
            "dark:hover:bg-primary-wu hover:bg-primary-wu hover:brightness-90 dark:hover:brightness-90",
          downvoted &&
            "dark:hover:bg-gray-wu hover:bg-gray-wu hover:brightness-90 dark:hover:brightness-90"
        )}
      >
        <ArrowBigDown
          className={cn(
            "size-6",
            "text-black dark:text-white",
            downvoted && "fill-foreground text-transparent"
          )}
        />
      </Button>
    </div>
  );
};

export default Rating;
